import { useSyncExternalStore } from 'react';

/*
 * Whether something arrived while the drawer was away.
 *
 * Held in the module rather than in the drawer, for the same reason the
 * drawer's own state is: what marks it is the socket handler and what clears it
 * is the drawer opening, and those two are nowhere near each other. It is not
 * written down — a mark that survives a reload is a mark for a reply the user
 * has almost certainly already read somewhere else.
 */
let unread = false;

const listeners = new Set<() => void>();

/** Whether the strip should be showing its dot right now. */
export function chatUnread(): boolean {
  return unread;
}

function set(next: boolean): void {
  if (unread === next) return;

  unread = next;
  listeners.forEach((listener) => listener());
}

/** A reply landed and nobody was looking. */
export function markChatUnread(): void {
  set(true);
}

/** Opening the drawer is seeing what is in it. */
export function clearChatUnread(): void {
  set(false);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

/** The mark, read reactively by whoever draws the strip. */
export function useChatUnread(): boolean {
  return useSyncExternalStore(subscribe, chatUnread, () => false);
}
